import axios from "axios";
import {
  Approval,
  ApprovalDetailResponse,
  ApprovalParams,
  ApprovalResponse,
  UpdateApprovalPayload,
} from "../types/Approvals";

export const getApprovals = async (params?: ApprovalParams) => {
  const response = await axios.request<ApprovalResponse>({
    url: "/sherpa/v0/api/approvals",
    method: "GET",
    params,
  });
  return response.data;
};

export const getApprovalById = async (id: number) => {
  const response = await axios.request<ApprovalDetailResponse>({
    url: `/sherpa/v0/api/approvals/${id}`,
    method: "GET",
  });
  return response.data;
};

export const updateApproval = async ({
  id,
  ...data
}: UpdateApprovalPayload) => {
  const response = await axios.request({
    url: `/sherpa/v0/api/approvals/${id}`,
    method: "PATCH",
    data,
  });
  return response.data;
};
